<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab title="Customer" active>
                <b-card-body>
                    <b-form @submit.prevent="updateCustomer()">
                        <b-form-group
                            id="input-group-code"
                            label="Code:"
                            label-for="code"
                        >
                            <b-input
                                id="code"
                                name="code"
                                v-model="model.code"
                                type="text"
                            ></b-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                        >
                            <b-input
                                id="input-name"
                                v-model="model.name"
                                :error="errors.first('name')"
                                type="text"
                                required
                            ></b-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-1"
                            label="Email address:"
                            label-for="input-1"
                        >
                            <b-input
                                name="email"
                                v-model="model.email"
                                type="email"
                                required
                            ></b-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-1"
                            label="Telephone:"
                            label-for="phone"
                        >
                            <b-input
                                id="phone"
                                name="phone"
                                v-model="model.phone"
                                type="tel"
                                required
                            ></b-input>
                        </b-form-group>

                        <b-form-row class="mt-6">
                            <b-col class="text-center">
                                <b-button
                                    @click="
                                        $refs['locationSection'].setSearchMode()
                                    "
                                    variant="secondary"
                                    :disabled="updating"
                                    >Change Location</b-button
                                >
                                <b-button
                                    type="submit"
                                    variant="primary"
                                    v-show="
                                        user_permissions.includes(
                                            'update.customers'
                                        )
                                    "
                                    :disabled="updating"
                                    >{{
                                        updating
                                            ? 'Saving Changes...'
                                            : 'Save Changes'
                                    }}</b-button
                                >

                                <b-button
                                    v-if="this.model.id"
                                    @click="deleteCustomer()"
                                    variant="warning"
                                    v-show="
                                        user_permissions.includes(
                                            'delete.customers'
                                        )
                                    "
                                >
                                    Delete Customer
                                </b-button>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-card-body>
            </b-tab>
            <b-tab title="Location">
                <b-card-body>
                    <location-section
                        ref="locationSection"
                        v-model="model.location_section_id"
                        :hide-controls="true"
                        title="Location"
                        @update-section-model="updateSectionEvent"
                    ></location-section>
                </b-card-body>
            </b-tab>
            <b-tab title="Users" :disabled="!model.id">
                <b-card-body>
                    <customer-users :customer_id="model.id"></customer-users>
                </b-card-body>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import locationMixins from '@/mixins/locationMixins'
import utilityMixins from '@/mixins/utilityMixins'

import LocationSection from '@/views/Location/LocationSection'
import CustomerUsers from './CustomerUsers.vue'

export default {
    name: 'view-customer',
    components: { CustomerUsers, LocationSection },
    mixins: [popupMixins, locationMixins, utilityMixins],
    data() {
        return {
            model: {
                id: 0,
                code: '',
                name: '',
                email: '',
                phone: '',
                location_section_id: 0,
                location: null,
                section_name: null,
            },
            updating: false,
        }
    },
    computed: {
        customer() {
            return this.$store.getters['customers/customer']
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {
        customer: function (val) {
            console.log('val', val)
            this.model = val
        },
    },
    methods: {
        async updateCustomer() {
            try {
                this.updating = true
                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Form Not Completed Properly!!')

                await this.$store.dispatch('customers/update', {
                    ...this.model,
                    ...(this.sectionLocationEventData || {}),
                })
                this.doToast('Customer Updated', 'Updated', 'success')
            } catch (error) {
                this.doToast(
                    'Error Detected',
                    error.message || error.response.data.error.message,
                    'warning'
                )
            } finally {
                this.updating = false
            }
        },

        async deleteCustomer() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/customers',
                deleteRoute: 'customers/delete',
            }
            const notificationFields = {
                type: 'Customer',
                errorMsg:
                    'Unable to delete Customer, an association exists with other records',
            }

            this.deleteItem(notificationFields, model, routes)
        },
    },
    mounted() {
        this.$store.dispatch('customers/fetchById', this.$route.params.id)
    },
}
</script>
<style></style>
